module.exports = __webpack_public_path__ + "images/mobile/icon-connect-arrow-success-7bd932d7058955cfa9048d3e23dc88c7.png";